package com.hyperether.goodjob.scenes.contacts.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.snapshots.SnapshotStateList
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.ContactDetailsText
import org.jetbrains.compose.resources.painterResource


@Composable
fun SitesList(
    sites: SnapshotStateList<Site>,
    onEditSiteClick: (String?) -> Unit
) {

    LazyColumn(
        modifier = Modifier.fillMaxSize().padding(start = Dp(16f), end = Dp(16f))
    ) {
        if (sites.isNotEmpty()) {
            items(sites.takeIf { it.isNotEmpty() } ?: emptyList()) { site ->
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = Dp(15f))
                        .border(Dp(1f), Color.LightGray, RoundedCornerShape(Dp(8f)))
                ) {
                    Column(modifier = Modifier.padding(Dp(12f))) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = Dp(4f), bottom = Dp(8f)),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                text = site.siteName ?: "",
                                fontSize = Sp(16f),
                                fontWeight = FontWeight.Bold,
                                color = BlueApp,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.weight(1f)
                            )
                            if (site.personName?.isNotEmpty() == true)
                                Text(
                                    text = site.personName ?: "",
                                    fontSize = Sp(14f),
                                    color = ContactDetailsText,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis,
                                    modifier = Modifier.weight(0.5f)
                                )
                            Image(
                                painter = painterResource(Res.drawable.edit),
                                contentDescription = null,
                                modifier = Modifier.weight(0.2f).clickable {
                                    onEditSiteClick(site.id)
                                }
                            )
                        }
                        if (site.addressObject?.address?.isNotEmpty() == true)
                            Text(
                                text = site.addressObject?.address ?: "",
                                fontSize = Sp(14f),
                                color = ContactDetailsText,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        if (site.personEmail?.isNotEmpty() == true)
                            Text(
                                text = site.personEmail ?: "",
                                fontSize = Sp(14f),
                                color = ContactDetailsText,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        if (site.personPhone?.isNotEmpty() == true)
                            Text(
                                text = site.personPhone ?: "",
                                fontSize = Sp(14f),
                                color = ContactDetailsText,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                    }
                }
            }
        }
    }
}
